import React from 'react';
import { CheckboxGroup, Checkbox } from '@guardian/src-checkbox';
import { FieldLabel } from './FieldLabel';
export const CheckboxSelect = ({ formField, formData, setFormData }) => (React.createElement(React.Fragment, null,
    React.createElement(FieldLabel, { formField: formField }),
    React.createElement(CheckboxGroup, { name: formField.name }, formField.options.map((option, index) => {
        // data related to this field is mapped to `formData` using `formField.id`
        // We cannot assume that the data exists, so we need to check if `formField.id` key exists in `formData`
        const selectedCheckboxesArray = formField.id in formData ? formData[formField.id] : [];
        const isCheckboxChecked = !!selectedCheckboxesArray.find((ele) => ele === option.value);
        const filterOutCheckboxFromArray = () => selectedCheckboxesArray.filter((ele) => ele !== option.value);
        const addCheckboxToArray = () => [
            ...selectedCheckboxesArray,
            option.value,
        ];
        return (React.createElement(Checkbox, { "data-testid": `form-field-${option.value}`, key: index, label: option.label, value: option.value, checked: isCheckboxChecked, onChange: () => {
                setFormData({
                    ...formData,
                    [formField.id]: isCheckboxChecked
                        ? filterOutCheckboxFromArray()
                        : addCheckboxToArray(),
                });
            } }));
    }))));
